import { isEmpty } from 'lodash';
import { useInfiniteQuery } from 'react-query';
import { queryGet } from '@pocapan/shared/utils/queryClient';

const DEFAULT_PAGE = 10;

export default function useAdminPhotoCardEventsQuery({
  artistId,
  memberId,
  eventIds,
  photoCardCategories,
  likedEventOnly,
  adminMode,
  perPage
}) {
  async function fetchEvents({ pageParam = 1 }) {
    const queryParams = new URLSearchParams({
      per_page: perPage || DEFAULT_PAGE,
      page: pageParam
    });

    if (memberId) {
      queryParams.append('member_id', memberId);
    }

    if (!isEmpty(eventIds)) {
      queryParams.append('event_ids', eventIds);
    }

    if (!isEmpty(photoCardCategories)) {
      queryParams.append('photo_card_categories', photoCardCategories);
    }

    if (likedEventOnly) {
      queryParams.append('liked_event_only', true);
    }

    if (adminMode) {
      queryParams.append('admin_mode', adminMode);
    }

    const url = `/api/v1/artists/${artistId}/events?${queryParams.toString()}`;
    try {
      const data = await queryGet(url);
      return data;
    } catch (_error) {
      throw new Error('Error fetching paginated data.');
    }
  }

  const { data, isFetching, fetchNextPage, hasNextPage } = useInfiniteQuery(
    [
      'AdminPhotoCardEvents',
      artistId,
      memberId,
      likedEventOnly,
      eventIds,
      photoCardCategories,
      adminMode
    ],
    fetchEvents,
    {
      enabled: !!artistId && !!memberId,
      getNextPageParam: (lastPage, _) => lastPage?.meta?.pagination?.nextPage,
      cacheTime: 0,
      staleTime: 0
    }
  );

  return {
    data,
    isFetching,
    fetchNextPage,
    hasNextPage
  };
}
